var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PageContainer',{scopedSlots:_vm._u([{key:"header",fn:function(){return [_c('PageHeader',{attrs:{"title":"База знаний"}})]},proxy:true},{key:"content",fn:function(){return [_c('RouterView',{key:_vm.$route.path})]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }